if (!customElements.get("collection-feature")) {
  customElements.define(
    "collection-feature",
    class CollectionFeature extends HTMLElement {
      constructor() {
        super();
        this.onItemHover = this.onItemHover.bind(this);
      }

      connectedCallback() {
        // Find the wrapper element to apply styles to
        this.section = this.closest('.collection-feature__wrapper');
        // Fallback if wrapper isn't found (e.g., structure changed), use the component itself if it has the styles
        if (!this.section) {
          this.section = this;
        }

        this.items = this.querySelectorAll(".collection-feature__item");
        this.images = this.querySelectorAll(".collection-feature__image-item");

        this.items.forEach((item) => {
          item.addEventListener("mouseenter", this.onItemHover);
        });
      }

      onItemHover(event) {
        const item = event.currentTarget;
        const targetBlockId = item.dataset.blockId;

        // Update active class on images
        this.images.forEach((img) => {
          if (img.dataset.blockId === targetBlockId) {
            img.classList.add("is-active");
          } else {
            img.classList.remove("is-active");
          }
        });

        // Change Section Colors
        const color = item.dataset.hoverColor;
        const background = item.dataset.hoverBackground;

        // Debugging to ensure we are getting values
        // console.log('Hover:', targetBlockId, color, background);

        if (color) {
          this.section.style.setProperty('--color-custom-text', color);
          // Also set direct color property as fallback/override if variable usage is inconsistent
          this.section.style.color = color;
        } else {
          this.section.style.removeProperty('--color-custom-text');
          this.section.style.color = '';
        }

        if (background) {
          this.section.style.setProperty('--color-background', background);
          // Also set direct background property as fallback
          this.section.style.background = background;
        } else {
          this.section.style.removeProperty('--color-background');
          this.section.style.background = '';
        }
      }

      disconnectedCallback() {
        this.items.forEach((item) => {
          item.removeEventListener("mouseenter", this.onItemHover);
        });
      }
    }
  );
}
